import { cn } from "@/lib/utils";

export interface BarDatum {
  key: string;
  label: string;
  value: number;
  /** Qiymat yonida ko'rsatiladigan matn (masalan, pul). Berilmasa — raqam. */
  display?: string;
}

/**
 * Gorizontal ustunlar.
 *
 * Kategoriyalar NOMINAL (rol, holat, kurs nomi) — ya'ni tartibi ma'no
 * bermaydi, shuning uchun hammasi BITTA rangda (`--chart-1`). Har bir
 * ustunni o'z rangiga bo'yash uzunlik allaqachon ko'rsatgan narsani
 * ikkinchi marta kodlash bo'lardi va identifikatsiya kanalini behuda
 * sarflardi.
 *
 * Qiymat HAR DOIM matn bilan yozilgan: grafik rangga ham, uzunlikka ham
 * yagona tayanch emas.
 */
export const BarList = ({ data, className }: { data: BarDatum[]; className?: string }) => {
  const max = Math.max(...data.map(item => item.value), 1);

  return (
    <ul className={cn("flex flex-col gap-3", className)}>
      {data.map(item => (
        <li key={item.key} className="flex flex-col gap-1.5">
          <div className="flex items-baseline justify-between gap-3 text-sm">
            <span className="text-foreground min-w-0 truncate">{item.label}</span>
            <span className="text-muted-foreground shrink-0 tabular-nums">
              {item.display ?? item.value.toLocaleString("en-US").replaceAll(",", " ")}
            </span>
          </div>
          <div className="bg-muted h-2 w-full overflow-hidden rounded-full">
            <div
              className="bg-chart-1 h-full rounded-full"
              style={{ width: `${Math.max((item.value / max) * 100, item.value > 0 ? 2 : 0)}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
};
